import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Client from '../../models/Client'

export interface ClientListState extends PaginatedApiState {
  clients?: Client[]
}

const ClientList = (state: ClientListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ClientListState>('CLIENT_LIST')(state, action)
  }
}

export default ClientList
